'use client'

import Image from 'next/image'
import { forwardRef } from 'react'

const NotificationBell = forwardRef(function NotificationBell(
  { unreadCount = 0, ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      type="button"
      aria-label={`Notifications${unreadCount > 0 ? `, ${unreadCount} unread notifications` : ''}`}
      className="relative flex size-10 shrink-0 items-center justify-center rounded-full bg-transparent text-white transition-colors hover:bg-neutral-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white data-[state=open]:bg-neutral-blue-700"
      {...props}
    >
      <Image src="/notifications/bell.svg" alt="" width={24} height={24} />
      {unreadCount > 0 ? (
        <span
          aria-hidden="true"
          className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-orange-500 px-1 text-[10px] font-bold leading-none text-white"
        >
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      ) : null}
    </button>
  )
})

export default NotificationBell
